import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['card', 'button', 'saveForm', 'resetForm', 'done', 'instruction' ]

  initialize() {
    this.ask()
  }

  select(event) {
    const button = event.currentTarget
    const question = this.questionCard
    if (question && question.dataset.cms === button.dataset.cms) {
      question.classList.remove('match-word-asked')
      question.classList.add('match-word-muted')
      question.classList.add('match-word-done')
      button.disabled = true
      button.classList.add('btn-outline-success')
      button.classList.remove('btn-outline-dark')
      this.ask()
    }
  }

  ask() {
    const unasked = this.cardTargets.find((card) => { return card.classList.contains('match-word-unasked') })

    if (unasked) {
      unasked.classList.remove('match-word-unasked')
      unasked.classList.add('match-word-asked')
    } else {
      this.finish()
    }
  }

  finish() {
    Rails.fire(this.saveFormTarget, 'submit')
    Rails.fire(this.element, 'exercisedone')
    this.doneTarget.classList.remove('d-none')
    this.resetFormTarget.classList.remove('d-none')
    this.instructionTarget.classList.add('d-none')
    this.buttonTargets.forEach(b => { b.classList.add('d-none') })
    this.cardTargets.forEach(c => { c.classList.remove('match-word-muted') })
  }

  reset(event) {
    Rails.fire(this.element, 'exercisereset')
    const response = event.detail[0]
    this.element.parentNode.innerHTML = response
  }

  get questionCard() {
    return this.cardTargets.find((card) => { return card.classList.contains('match-word-asked') })
  }
}
